import { Box, BoxProps, ColorOptions, Text, TextProps } from '@jfs/ui-new'

interface TitleProps {
  title?: string
  color?: ColorOptions
}

export const Title = ({ title = '', color = 'PRIMARY_STORNG' }: TitleProps) => {
  return (
    <Box {...styles.container}>
      <Text {...styles.title} color={color}>
        {title}
      </Text>
    </Box>
  )
}

const styles = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  title: {
    fontFamily: 'jioType-medium',
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 24,
    color: 'PRIMARY_STORNG',
  } as TextProps,
}
